import React from "react";
import { useTranslation } from "react-i18next";

interface Tab {
  key: string;
  label: string;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabKey: string) => void;
  className?: string;
  tabClassName?: string;
  activeTabClassName?: string;
  inactiveTabClassName?: string;
  indicatorClassName?: string;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = "",
  tabClassName = "",
  activeTabClassName = "text-[#002AA3]",
  inactiveTabClassName = "text-gray-600 hover:text-gray-900",
  indicatorClassName = "bg-[#0033CC]",
}) => {
  const { t } = useTranslation();

  return (
    <div className={`mb-6 ${className}`}>
      <div className="flex border-b border-gray-200 space-x-2 xl:space-x-8 overflow-x-auto max-w-full lg:overflow-x-visible hide-scrollbar">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => onTabChange(tab.key)}
              className={`relative px-1 py-4 text-[10px] md:text-xs lg:text-sm font-medium transition-colors duration-200 ${tabClassName} ${
                isActive ? activeTabClassName : inactiveTabClassName
              }`}
            >
              {t(tab.label)}
              {isActive && (
                <div
                  className={`absolute bottom-0 left-0 right-0 h-0.5 ${indicatorClassName}`}
                ></div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TabNavigation;
